/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */

export type WebhookEventStatus = typeof WebhookEventStatus[keyof typeof WebhookEventStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebhookEventStatus = {
  Received: 'Received',
  Dispatching: 'Dispatching',
  Delivered: 'Delivered',
  Failed: 'Failed',
  Abandoned: 'Abandoned',
} as const;
